// GRAVY-10814. The Unpaid Break dropdown labels zero as "No break", not
// "0 min" (Figma 39621:199609). Its own module because the Review modal renders
// the options and the queue rows read the same value back.
export const breakLabel = (minutes: number): string =>
  minutes === 0 ? 'No break' : `${minutes} min`;
